import {
    apiConstants,
} from '../config';

let code = apiConstants.code;
let codeAPI = apiConstants.codeAPI;
const state = {
    error: null,
    loading: false,
    data: {
        code: code,
        codeAPI: codeAPI,
        module: {},
        panels: {
            home: {
                acl: {
                    view: null,
                },
                url: {
                },
            },
            headernav: {
                tools: [
                    {component: 'dashboard', title: 'dashboard.title'},
                ]
            },
        },
        tools: {
            backoffice: {
                active: true,
                title: 'backoffice.titles',
                label: 'backoffice.label',
                panel: {
                    show: false,
                },
                acl: {
                    view: null,
                },
                url: {
                    view: `:moduleCodegestao.home`,
                }
            },
            layers: {
                active: true,
                title: 'layers.titles',
                label: 'layers.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: null,
                },
                url: {
                    getLayers: `${codeAPI}/:applicationCode/front/map/layers`,
                },
                selected: null,
            },
            regulations: {
                active: true,
                title: 'regulations.titles',
                label: 'regulations.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: null,
                },
                url: {
                    getData: `${codeAPI}/:applicationCode/front/regulations`,
                },
            },
            navsearch: {
                active: true,
                panel: {
                    show: true,
                    showDefault: true,
                    categories: [{
                        'id': 'addr',
                        'name': 'navsearch.address.title',
                        'url': '../gateway/address/search',
                        'listGroup': 'adminName1',
                        'labelTemplate': 'navsearch.address.labelTemplate',
                        'subLabelTemplate': null,
                        'placeholder': 'navsearch.address.placeholder'
                    }],
                    search: {
                        category: null,
                        item: null,
                        search: null,
                    },
                },
            },
            catalog: {
                acl: {
                    view: null,
                },
            },
            identify: {
                acl: {
                    view: null,
                },
            },
            annotations: {
                acl: {
                    view: null,
                },
            },
            measure: {
                acl: {
                    view: null,
                },
            },
            print_visible_emissions: {
                active: true,
                title: 'print_visible_emissions.titles',
                label: 'print_visible_emissions.label',
                panel: {
                    show: false,
                    loaded: false,
                },
                acl: {
                    view: null,
                },
                url: {
                    capabilitiesPrint: `${codeAPI}/:applicationCode/front/print/visible/capabilities`,
                    createPrint: `${codeAPI}/:applicationCode/front/print/visible`,
                    getStatusPrint: `${codeAPI}/:applicationCode/front/print/visible/job/:id`,
                }
            },
        },
         map: {
            loading: false,
            action: null,
            config: {
                layers: {
                    search: {
                        source: 'vs_search',
                        layer: 'lyr_search',
                        zindex: 1000,
                        timeout: 10000,
                        duration: 1500,
                        zoomScale: 1.3,
                    },
                },
                style: {

                },
                interactions: {
                    draw: {
                    },
                },
            }
        },
        config: {

        },
    },
};

export default state;